module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block, _vm.getBlockModifiers()],
    domProps: {
      "innerHTML": _vm._s(_vm.data.html)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62a58ed4","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Html.vue
// module id = 431
// module chunks = 0